import * as React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import to from 'await-to-js'
// @ts-ignore
import { Button } from 'relevant-ui'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { Props, State, DispatchProps, IFormatedOrg } from './types'

import {
  getOrganizationsUser,
  setEditingOrganization,
  setDeletingOrganization,
  deleteOrganization,
  setCurrentOrganisation,
  updateOrganization,
  createOrganization,
} from '@App/store/organizations/actions'

import './styles.scss'
import UiPage from '@App/components/blocks/UiPage'
import OrganizationForm from '@App/components/forms/OrganizationForm'
import {
  setShowModal,
  setHideModal,
  ModalType,
  ModalSize,
} from '@App/store/modal'
import { toggleFieldAction } from '@App/store/toggleField'
import Modal from '@App/components/blocks/Modal'
import ModalConfirm from '@App/components/blocks/Modal/ModalConfirm'
import { Fields } from '@App/components/forms/OrganizationForm/types'
import { getFormValues } from 'redux-form'
import { IOrganizations } from '@App/store/organizations'
import { getApplications } from '@App/store/application/actions'

class OrganizationsPage extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)

    props.loadOrganizations()
    props.getApplications()

    this.state = {
      deleteOrg: 0,
      search: '',
    }

    this.onHandleSubmit = this.onHandleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDeleteOrg = this.handleDeleteOrg.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillMount() {
    const { setCurrentOrganisation, organizations } = this.props

    const first = {
      id: organizations[0]?.id,
      title: organizations[0]?.name,
      app: organizations[0]?.applications,
    }

    setCurrentOrganisation(first)
  }

  handleDelete(e) {
    e.preventDefault()

    this.setState({ deleteOrg: this.props.current.id })
    return this.props.setShowModal(ModalType.DELETE)
  }

  handleDeleteOrg() {
    this.props.deleteOrganization(this.state.deleteOrg)
    return this.props.setHideModal()
  }

  async onHandleSubmit(e, data) {
    e.preventDefault()

    const {
      current,
      updateOrganization,
      orgFormValues,
      toggleFieldAction,
      createOrganization,
    } = this.props

    const body = {
      ...orgFormValues,
      segments: data,
    }

    if (current) {
      const [err] = await to(updateOrganization(current.id, body))
      if (!err) {
        return toggleFieldAction(true)
      }
      return toggleFieldAction(false)
    }

    const [err] = await to(createOrganization(body))
    if (!err) {
      return toggleFieldAction(true)
    }
    return toggleFieldAction(false)
  }

  handleClick() {
    const { toggleFieldAction, setCurrentOrganisation } = this.props

    toggleFieldAction(false)
    setCurrentOrganisation(null)
    return
  }

  render() {
    const {
      t,
      current,
      organizations,
      setCurrentOrganisation,
      toggleFieldAction,
    } = this.props

    const organizationsList: IFormatedOrg[] = organizations?.map((el: IOrganizations) => ({
      id: el.id,
      title: el.name,
      app: el.applications,
    }))

    return (
      <div style={{ height: '100%' }}>
        <UiPage
          title="Organisation"
          search={t('search_org')}
          button={t('new_org')}
          data={organizationsList?.filter((el: IFormatedOrg) => el.title.toLowerCase().includes(this.state.search.toLowerCase())) || []}
          handleClick={this.handleClick}
          handleSearch={(e: any) => this.setState({ search: e.target.value })}
          setCurrent={(e: any) => setCurrentOrganisation(e)}
          withHeader
        >
          <OrganizationForm
            handleSubmit={(e: any, data: any) => this.onHandleSubmit(e, data)}
            handleCanceled={() => toggleFieldAction(true)}
            handleDelete={this.handleDelete}
          />
        </UiPage>
        <Modal
          type={ModalType.DELETE}
          size={ModalSize.SMALL}
          handleClose={() => { }}
        >
          <ModalConfirm
            title="Supprimer l'organisation"
            description={`Etes vous sur de vouloir supprimer l'organisation: ${current?.title}`}
            handleCancel={setHideModal}
            handleConfirm={this.handleDeleteOrg}
          />
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => {
  return {
    loadOrganizations: () => dispatch(getOrganizationsUser()),
    setEditingOrganization: (id: Number) =>
      dispatch(setEditingOrganization(id)),
    setDeletingOrganization: (id: Number) =>
      dispatch(setDeletingOrganization(id)),
    deleteOrganization: (id: Number) => dispatch(deleteOrganization(id)),
    setCurrentOrganisation: (org: any) => dispatch(setCurrentOrganisation(org)),
    setShowModal: (type: any) => dispatch(setShowModal(type)),
    setHideModal: () => dispatch(setHideModal()),
    toggleFieldAction: (bool: boolean) => dispatch(toggleFieldAction(bool)),
    updateOrganization: (id: number, body: any) =>
      dispatch(updateOrganization(id, body)),
    createOrganization: (body: any) => dispatch(createOrganization(body)),
    getApplications: () => dispatch(getApplications()),
  }
}

const mapStateToProps = (state: any) => {
  const orgFormValues = getFormValues(Fields.FORM)(state)
  const {
    organizations: { list, deleting, current },
  } = state

  return {
    deleting,
    current,
    orgFormValues,
    organizations: list,
  }
}

export default compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(OrganizationsPage)
